export default "__VITE_ASSET__VLR2yDDe__"